<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">ارسال سفارش خرید</h2>
            <p class="text-sm text-purple-50">انتخاب کالا و تنظیم وضعیت</p>
          </div>
        </div>
      </div>

      <!-- Request Items -->
      <div class="space-y-3">
        <div 
          v-for="item in request_items"
          :key="item.Id"
          @click="goToDetail(item)"
          v-longclick="() => long_click(item)"
          :class="[
            'bg-white rounded-xl border p-5 cursor-pointer transition-all duration-200',
            item.selected ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:shadow-md hover:border-purple-300'
          ]"
        >
          <div class="flex items-center gap-3 mb-3">
            <div class="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div class="w-full">
              <h3 class="text-base font-bold text-gray-900">{{ item.ProductName }}</h3>
            </div>
            <div v-if="item.selected" class="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          
          <div class="grid grid-cols-2 gap-4">
            <div class="text-center p-3 bg-gray-50 rounded-lg">
              <p class="text-xs text-gray-600 mb-1">تعداد</p>
              <p class="text-sm font-bold text-gray-900">{{ item.Qty }} عدد</p>
            </div>
            <div class="text-center p-3 bg-gray-50 rounded-lg">
              <p class="text-xs text-gray-600 mb-1">شعبه</p>
              <p class="text-sm font-bold text-gray-900">{{ item.SourceBranchName }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="request_items.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
      </div>

      <!-- Action Button -->
      <button 
        v-if="enable_finalize"
        @click="dialog_model = true"
        class="w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
      >
        {{ $t('add_status') }}
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      </button>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

    </div>

    <!-- Product Info Dialog -->
    <div v-if="product_info_dialog" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-end justify-center p-4 pb-8">
      <div class="bg-white rounded-t-2xl shadow-xl w-full max-w-md max-h-90vh overflow-hidden flex flex-col">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-purple-600 to-purple-700 flex items-center justify-between flex-shrink-0">
          <h2 class="text-lg font-bold text-white">{{ $t('information') }}</h2>
          <button 
            @click="product_info_dialog = false"
            class="w-8 h-8 rounded-lg bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 flex items-center justify-center transition-colors"
          >
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <!-- Body -->
        <div class="px-6 py-6 overflow-y-auto flex-1 space-y-4">
          <div class="space-y-3">
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm font-bold text-gray-900">{{ selected_product_info.ProductName }}</p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">شعبه: <span class="font-bold text-gray-900">{{ selected_product_info.SourceBranchName }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">{{ $t('technicianQ') }}: <span class="font-bold text-gray-900">{{ selected_product_info.TechName }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">{{ $t('summaryQ') }}: <span class="font-bold text-gray-900">{{ selected_product_info.ProductDesc }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">{{ selected_product_info.Qty }} {{ $t('numbers') }}</p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">کد درخواست: <span class="font-bold text-gray-900">{{ selected_product_info.RequestCode }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">{{ $t('referDescriptionQ') }}: <span class="font-bold text-gray-900">{{ selected_product_info.Summary }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">قیمت خرید: <span class="font-bold text-gray-900">{{ selected_product_info.PurchaseAmount }}</span></p>
            </div>
            <div class="p-3 bg-gray-50 rounded-lg">
              <p class="text-sm text-gray-600">قیمت فروش: <span class="font-bold text-gray-900">{{ selected_product_info.SaleAmount }}</span></p>
            </div>
          </div>

          <!-- Images -->
          <div v-if="selected_product_info.Images" class="grid grid-cols-2 gap-3 mt-4">
            <img 
              v-for="img in selected_product_info.Images" 
              :key="img"
              @click="open_image(img)"
              :src="img"
              class="w-full h-32 object-cover rounded-lg cursor-pointer hover:opacity-80 transition-opacity"
            />
          </div>
        </div>
        
        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex-shrink-0">
          <button 
            @click="product_info_dialog = false"
            class="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-medium rounded-lg transition-all duration-200"
          >
            {{ $t('close') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Add Status Dialog -->
    <div v-if="dialog_model" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-end justify-center p-4 pb-8">
      <div class="bg-white rounded-t-2xl shadow-xl w-full max-w-md max-h-90vh overflow-hidden flex flex-col">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-purple-600 to-purple-700 flex items-center justify-between flex-shrink-0">
          <h2 class="text-lg font-bold text-white">{{ $t('add_status') }}</h2>
          <button 
            @click="dialog_model = false"
            class="w-8 h-8 rounded-lg bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 flex items-center justify-center transition-colors"
          >
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <!-- Body -->
        <div class="px-6 py-6 overflow-y-auto flex-1 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('NewStatusChangeStatus') }}</label>
            <select 
              v-model="selected_status_for_change"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 appearance-none"
              style="border: 1px solid #d1d5db !important;"
            >
              <option 
                v-for="status in status_list" 
                :key="status.value" 
                :value="status.value"
              >
                {{ status.label }}
              </option>
            </select>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('summary') }}</label>
            <textarea 
              v-model="status_summary"
              rows="4"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              style="border: 1px solid #d1d5db !important;"
            ></textarea>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('signature_place') }}</label>
            <div class="border border-gray-300 rounded-lg overflow-hidden" style="border: 1px solid #d1d5db !important;">
              <VueSignaturePad ref="signaturePad" :options="signature_options" />
            </div>
          </div>
        </div>
        
        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3 flex-shrink-0">
          <button 
            @click="dialog_model = false"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
          >
            {{ $t('cancel') }}
          </button>
          <button 
            v-if="selected_status_for_change != 0"
            @click="go_to_finalize(0)"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-medium rounded-lg transition-all duration-200"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  import VueSignaturePad from 'vue-signature-pad'
  Vue.use(VueSignaturePad)

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        signature_options: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 2.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
          onBegin: () => {
          },
          onEnd: () => {
          }
        },
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_device_status();
    },

    methods: {
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          RowCount: this.page,
          StatusId : self.request_statuses[12]
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferByUserId', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              // console.log("my status", self.request_statuses[12])
              // response.data.Items = response.data.Items.filter(x => x.LastStatus == self.request_statuses[12]);

              response.data.Items.forEach(function (number) {
                self.request_items.push(JSON.parse(JSON.stringify(number)))
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        // if (item.related_products != null) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        // }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize(index_item) {
       var self = this;
        var array = this.request_items.filter(x => x.selected == true);
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
console.log(array)
        const send_data = {
          GRequestProductId: array[index_item].GoodsRequestProductId,
          StatusId: this.selected_status_for_change,
          Summary: this.status_summary,
          UserId: user_id,
        };

        this.axios.post('/AddGoodsRequestStatus', send_data, {})
          .then(response => {
if(array.length-1 == index_item){
  bus.$emit('show_toast', [2000, response.data.msg])
  self.dialog_model = false
  self.get_pre_requests()
  self.enable_finalize = false;

}else{
  self.go_to_finalize(index_item+1)
}
          }).catch(e => {
          this.errors.push(e)
        })

        },
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            self.status_list = [{label: self.$t('select_status'), value: 0},
              {label: self.$t('returned'), value: self.request_statuses[9]},
              {label: self.$t('sent_to_technician'), value: self.request_statuses[10]},
              {label: self.$t('sent_to_warehouse'), value: self.request_statuses[13]},
              {label:"تحویل تعمیرگاه مربوطه شد", value: self.request_statuses[14]}
            ]

            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },
      undo () {
        this.$refs.signaturePad.clearSignature()
      },
      save () {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png')
        // var data_image = this.$refs.signaturePad.getPropImagesAndCacheImages()
        // console.log(this.$refs.signaturePad.getPropImagesAndCacheImages());
        // console.log(data);
        // Usage example:
        var file = this.dataURLtoFile(data, 'signature.png')
        console.log(file)
        // this.$refs.signaturePad.fromData(data)
        this.upload_image(file)
      },
      upload_image (image_data) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', this.req_type)
        form_data.append('Picture', image_data)

        //
        // const send_data = {
        //   "UserId": user_id,
        // };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            self.send_signature(response.data.ArchiveId, response.data.ImageName)
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type:mime })
      },

      send_signature (archive_id, file_name) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()

        var sign_type = 0

        if (this.req_type == 4) {
          sign_type = 1
        }
        if (this.req_type == 5) {
          sign_type = 2
        }

        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          ImageName: file_name,
          ArchiveId: archive_id,
          SigType: sign_type,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.$router.push({name: 'attachment', params: {'rec_id': self.$route.params.rec_id}})
              if (self.req_type == 4 || self.req_type == 5) {
                self.$router.push({ name: 'requestAddress', params: { rec_id: self.$route.params.rec_id } })
              }
            } else {
              bus.$emit('show_toast', [1500, self.$t('errorUploadSign')])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
